import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import DatalistInput from './DatalistInput';
import CollapsiblePaginatedPanel from './CollapsiblePaginatedPanel';
import { emptyPaymentRow, inputClassName } from '../../utils/assetHelpers';

const PaymentHistoryEditor = ({
    rows,
    onChange,
    currencyOptions = [],
    title = 'Payment History',
    pageSize = 5,
}) => {
    const updateRow = (absoluteIndex, field, value) => {
        const next = rows.map((row, i) => (i === absoluteIndex ? { ...row, [field]: value } : row));
        onChange(next);
    };

    const removeRow = (absoluteIndex) => {
        onChange(rows.filter((_, i) => i !== absoluteIndex));
    };

    const latest = rows[rows.length - 1];
    const summaryDetail = latest
        ? `Latest: ${latest.currency || '-'} ${latest.amount ?? ''}${latest.paymentDate ? ` on ${latest.paymentDate}` : ''}`
        : '';

    return (
        <CollapsiblePaginatedPanel
            title={title}
            items={rows}
            pageSize={pageSize}
            countLabel="payment record"
            summaryDetail={summaryDetail}
            addLabel="Add payment"
            onAdd={() => onChange([...rows, emptyPaymentRow()])}
            emptyText="No payment records yet."
        >
            {(visibleRows, startIndex) =>
                visibleRows.map((row, index) => {
                    const absoluteIndex = startIndex + index;
                    return (
                        <div
                            key={`payment-${absoluteIndex}`}
                            className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end border-b border-gray-100 pb-3 last:border-b-0 last:pb-0"
                        >
                            <DatalistInput
                                id={`payment-currency-${absoluteIndex}`}
                                label="Currency"
                                value={row.currency}
                                onChange={(value) => updateRow(absoluteIndex, 'currency', value)}
                                options={currencyOptions}
                                placeholder="SGD, USD..."
                            />
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    value={row.amount}
                                    onChange={(e) => updateRow(absoluteIndex, 'amount', e.target.value)}
                                    className={inputClassName}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Payment Date</label>
                                <input
                                    type="date"
                                    value={row.paymentDate}
                                    onChange={(e) => updateRow(absoluteIndex, 'paymentDate', e.target.value)}
                                    className={inputClassName}
                                />
                            </div>
                            <button
                                type="button"
                                onClick={() => removeRow(absoluteIndex)}
                                className="inline-flex items-center justify-center gap-1 px-3 py-2 text-red-600 hover:text-red-800"
                            >
                                <FiTrash2 className="w-4 h-4" />
                                Remove
                            </button>
                        </div>
                    );
                })
            }
        </CollapsiblePaginatedPanel>
    );
};

export default PaymentHistoryEditor;
